import styled from 'styled-components';

export const TypeCell = styled.div<{ color?: string }>`
  padding: 6px;
  background-color: ${(props) => props.color || 'white'};
  color: var(--color-surface);
  font-weight: 500;
  font-size: 12px;
  line-height: 90%;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;

  svg {
    cursor: pointer;
    color: var(--color-surface);
  }
`;
